<template>
  <div v-if="this.GET_ACCOUNT_DATA.id == 1 || has_perm('view_project_setting')">
    <!--  -->
    <div class="panel with-nav-tabs panel-primary">
      <div class="panel-heading">
        <ul class="nav nav-tabs">
          <li class="active">
            <a href="#tab1primary" data-toggle="tab">{{
              $t("project.general_settings")
            }}</a>
          </li>
          <li>
            <a href="#tab2primary" data-toggle="tab">{{
              $t("project_period_setting.monthlyCycle")
            }}</a>
          </li>
          <li>
            <a href="#tab3primary" data-toggle="tab">{{
              $t("project.bankAccountTitle")
            }}</a>
          </li>
          <li>
            <a href="#tab4primary" data-toggle="tab">{{
              $t("project.projectInvoiceOption")
            }}</a>
          </li>
          <li @click="onSelectTabs(5)">
            <a href="#tab5primary" data-toggle="tab">{{
              $t("configEmailGroup.title")
            }}</a>
          </li>
          <li>
            <a href="#tab6primary" data-toggle="tab">{{
              $t("configRevenueCode.title")
            }}</a>
          </li>
          <li>
            <a href="#tab7primary" data-toggle="tab">{{
              $t("feedback.config.departmentTitle")
            }}</a>
          </li>
          <li>
            <a href="#tab8primary" data-toggle="tab">{{
              $t("assetType.title")
            }}</a>
          </li>
        </ul>
      </div>
      <div class="panel-body">
        <div class="tab-content">
          <div class="tab-pane fade in active" id="tab1primary">
            <ProjectGeneralSettings :item="project_general_settings" />
          </div>
          <div class="tab-pane fade" id="tab2primary">
            <ProjectPeriodSettings
              :item="project_period_settings"
              v-on:periodUpdate="onPeriodUpdate"
            />
          </div>
          <div class="tab-pane fade" id="tab3primary">
            <ProjectBankAccounts :items="project_bank_accounts" />
          </div>
          <div class="tab-pane fade" id="tab4primary">
            <ProjectInvoiceOptions />
          </div>
          <div class="tab-pane fade" id="tab5primary">
            <ConfigEmailGroup ref="configEmailGroup"/>
          </div>
          <div class="tab-pane fade" id="tab6primary">
            <ConfigRevenueCode />
          </div>
          <div class="tab-pane fade" id="tab7primary">
            <DepartmentList />
          </div>
          <div class="tab-pane fade" id="tab8primary">
            <AssetType />
          </div>
        </div>
      </div>
    </div>
    <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ProjectGeneralSettings from "./ProjectGeneralSettings";
import ProjectPeriodSettings from "./ProjectPeriodSettings";
import ProjectBankAccounts from "./ProjectBankAccounts";
import ProjectInvoiceOptions from "./ProjectInvoiceOptions";
import ConfigEmailGroup from "./ConfigEmailGroup"
import ConfigRevenueCode from "./ConfigRevenueCode"
import DepartmentList from "../Case/DepartmentList";
import AssetType from "../Property/AssetType.vue"
import constantsData from "@/lib/constantsData";
import utils from "@/lib/utils";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import ProjectStatusEnum from "@/enum/projectStatusEnum";

export default {
  components: {
    ProjectGeneralSettings,
    ProjectPeriodSettings,
    ProjectBankAccounts,
    ProjectInvoiceOptions,
    ConfigEmailGroup,
    ConfigRevenueCode,
    DepartmentList,
    AssetType,
    "lte-core-alert": LTECoreAlert,
  },
  name: "ProjectInfoView",
  data() {
    return {
      project_general_settings: {
        project_name: "",
        project_id: "",
        project_code: "",
        project_owner: "",
        project_start_date: "",
        project_status: ProjectStatusEnum.ACTIVE,
        operator_name: "",
        operator_telephone: "",
        operator_website: "",
        operator_address: "",
        admin_email: null,
        project_description: "",
        project_stamp: null
      },
      project_period_settings: {
        monthly_calculate_period_start: "",
        monthly_calculate_period_end: "",
        monthly_data_input_period_start: "",
        monthly_data_input_period_end: "",
        monthly_due_date: "",
        project_id: ""
      },
      project_bank_accounts: [],
      dateOptions: constantsData.dateOptions,
      // project_service_default_fee: {
      //   water_fee: 0,
      //   electric_fee: 0
      // },
      // project_time_lease_back: {
      //   hour_checkin_default: 0,
      //   minute_checkin_default: 0,
      //   hour_checkout_default: 0,
      //   minute_checkout_default: 0
      // },
      project_smtp_settings: {
        project_name: "",
        sender_alias: "",
        description: "",
        page_size: 0,
        sub_content: "",
        smtp_domain: "",
        smtp_port: 0,
        smtp_sender: "",
        smtp_password: "",
        smtp_use_tls: true
      }
    };
  },
  watch: {
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_ACCOUNT_DATA"
    ])
  },
  methods: {
    ...mapActions([
      "SUCCESS_TOAST",
      "ERROR_TOAST",
      "GET_PROJECT_DETAIL"
    ]),
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onPeriodUpdate: function(data) {},
    onSelectTabs: function(value) {
      switch (value) {
        case 5:
          this.$refs.configEmailGroup.onRefreshData()
          break;
        default:
          break;
      }
    }
  },
  mounted() {
    const projectId = utils.getProjectSession()
    this.GET_PROJECT_DETAIL({ id: projectId }).then(
      function(res) {
        let data = res.data
        this.project_general_settings = {
          project_name: data.project_name,
          project_id: data.id,
          project_code: data.project_code,
          project_logo: data.project_logo,
          project_owner: data.project_owner,
          project_start_date: utils.formatSqlDate(data.project_start_date, null, this.dateOptions.format),
          project_status: data.project_status,
          operator_name: data.operator_name,
          operator_telephone: data.operator_telephone,
          operator_website: data.operator_website,
          operator_address: data.operator_address,
          project_description: data.project_description,
          project_date_format: data.date_view_options,
          admin_email: data.admin_email,
          managing_director: data.managing_director,
          customer_care_phone_number: data.customer_care_phone_number,
          company_name: data.company_name,
          tax_identification_number: data.tax_identification_number,
          project_stamp: data.project_stamp
        };
        this.project_period_settings = {
          monthly_calculate_period_start: data.monthly_calculate_period_start,
          monthly_calculate_period_end: data.monthly_calculate_period_end,
          monthly_data_input_period_start: data.monthly_data_input_period_start,
          monthly_data_input_period_end: data.monthly_data_input_period_end,
          monthly_due_date: data.monthly_due_date,
          project_id: data.id
        };
        this.project_bank_accounts = data.projectbankaccounts;
        // this.project_service_default_fee = {
        //   water_fee: data.sa_default_w_fee,
        //   electric_fee: data.sa_default_e_fee
        // }
        // this.project_time_lease_back = {
        //   hour_checkin_default: data.df_chkin_hour,
        //   minute_checkin_default: data.df_chkin_minute,
        //   hour_checkout_default: data.df_chkout_hour,
        //   minute_checkout_default: data.df_chkout_minute
        // }
        this.project_smtp_settings = {
          project_name: data.project_name,
          sender_alias: data.sender_alias,
          description: data.description,
          page_size: data.page_size,
          sub_content: data.sub_content,
          smtp_domain: data.smtp_domain,
          smtp_port: data.smtp_port,
          smtp_sender: data.smtp_sender,
          smtp_password: data.smtp_password,
          smtp_use_tls: data.smtp_use_tls
        };
        this.SUCCESS_TOAST();
      }.bind(this)
    )
    .catch(
      function() {
        this.ERROR_TOAST();
      }.bind(this)
    );
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.panel.with-nav-tabs .panel-heading {
  padding: 5px 5px 0 5px;
}
.panel.with-nav-tabs .nav-tabs {
  border-bottom: none;
}
.panel.with-nav-tabs .nav-justified {
  margin-bottom: -1px;
}
/********************************************************************/
/*** PANEL PRIMARY ***/
.with-nav-tabs.panel-primary .nav-tabs > li > a,
.with-nav-tabs.panel-primary .nav-tabs > li > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > li > a:focus {
  color: #fff;
}
.with-nav-tabs.panel-primary .nav-tabs > .open > a,
.with-nav-tabs.panel-primary .nav-tabs > .open > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > .open > a:focus,
.with-nav-tabs.panel-primary .nav-tabs > li > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > li > a:focus {
  color: #fff;
  background-color: #3071a9;
  border-color: transparent;
}
.with-nav-tabs.panel-primary .nav-tabs > li.active > a,
.with-nav-tabs.panel-primary .nav-tabs > li.active > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > li.active > a:focus {
  color: #428bca;
  background-color: #fff;
  border-color: #428bca;
  border-bottom-color: transparent;
}
.with-nav-tabs.panel-primary .nav-tabs > li.dropdown .dropdown-menu {
  background-color: #428bca;
  border-color: #3071a9;
}
.with-nav-tabs.panel-primary .nav-tabs > li.dropdown .dropdown-menu > li > a {
  color: #fff;
}
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > li
  > a:hover,
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > li
  > a:focus {
  background-color: #3071a9;
}
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a,
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a:hover,
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a:focus {
  background-color: #4a9fe9;
}</style>



// WEBPACK FOOTER //
// src/views/Project/ProjectInfoView.vue